import { PageTags } from "./../components/Head/HeadProps";

// Resource hints (preconnect, dns-prefetch) are sent as nginx `Link:`
// response headers from docker/nginx-video-upperfunnel-ui.conf so the
// browser can act on them before HTML is parsed. WAT-10590.
//
// NOTE: This relies on nginx being in front of the app. Local Next dev
// server (yarn dev / yarn dev:windows) bypasses nginx, so resource
// hints will be absent in localhost — verify perf changes on test1 or
// higher, not localhost.

export const pageTags: PageTags = {
  meta: [
    {
      charSet: "utf-8",
    },
    // NOTE: facebook-domain-verification is intentionally ordered BEFORE viewport.
    // Head.tsx render() emits this default meta array out of index order — meta[0]
    // and meta[2] render in the early <head> slots, meta[1] and meta[3+] render
    // later. Removing the old X-UA-Compatible entry (WAT-9791) shifted the indices;
    // putting facebook at meta[1] keeps charSet + viewport in their original early
    // slots, so the rendered <head> tag order is unchanged from before the IE removal.
    {
      content: `mrk8uqwlmh6i2xh1o5s3eo0u84exem`,
      name: `facebook-domain-verification`,
    },
    {
      content: `initial-scale=1.0, width=device-width, user-scalable=yes, maximum-scale=5.0`,
      name: `viewport`,
    },
  ],
  script: [],
  style: [
    // Bing Maps
    // `.bm_bottomLeftOverlay {` + `display: none;` + `}`,
  ],
};
